import { useQuery } from '@tanstack/react-query';
import { call } from '@/lib/api';

export type Owner = {
  id: number;
  name: string;
  picture: string | null;
};

export const ownerKeys = {
  all: ['owners'] as const,
};

/**
 * Options for the owner filter, shared by the Leads, Contacts, Accounts and
 * Offers boards. The server returns only people who already own something, so
 * the list is short and every entry can actually produce results.
 */
export function useOwners() {
  return useQuery({
    queryKey: ownerKeys.all,
    queryFn: () =>
      call<{ owners: Owner[] }>('user/owners', { method: 'GET' }).then((r) =>
        r.json(),
      ),
    staleTime: 5 * 60 * 1000,
  });
}
